import { render } from "./AccountDeleteForm.vue?vue&type=template&id=162f772e&ts=true&lang=pug"
import script from "./AccountDeleteForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountDeleteForm.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__